import {
  GET_CHALLANS,
  GET_CHALLANS_SUCCESS,
  GET_CHALLANS_FAIL,
  GET_CHALLAN_DETAILS,
  GET_CHALLAN_DETAILS_SUCCESS,
  GET_CHALLAN_DETAILS_FAIL,
  CREATE_CHALLAN,
  CREATE_CHALLAN_SUCCESS,
  CREATE_CHALLAN_FAIL,
  UPDATE_CHALLAN,
  UPDATE_CHALLAN_SUCCESS,
  UPDATE_CHALLAN_FAIL,
  CHECK_CHALLAN_NUMBER,
  CHECK_CHALLAN_NUMBER_SUCCESS,
  CHECK_CHALLAN_NUMBER_FAIL,
  RESET_CHALLAN_STATE,
} from "./actionTypes"

// Challan - This line cannot be edited or removed
export const getChallans = (page, limit, searchText, sort, sortByDate) => ({
  type: GET_CHALLANS,
  payload: {
    page,
    limit,
    searchText,
    sort,
    sortByDate,
  },
})

export const getChallansSuccess = challans => ({
  type: GET_CHALLANS_SUCCESS,
  payload: challans,
})

export const getChallansFail = error => ({
  type: GET_CHALLANS_FAIL,
  payload: error,
})

export const getChallanDetails = challanId => ({
  type: GET_CHALLAN_DETAILS,
  payload: challanId,
})

export const getChallanDetailsSuccess = challanDetails => ({
  type: GET_CHALLAN_DETAILS_SUCCESS,
  payload: challanDetails,
})

export const getChallanDetailsFail = error => ({
  type: GET_CHALLAN_DETAILS_FAIL,
  payload: error,
})

export const createChallan = (challan, history) => ({
  type: CREATE_CHALLAN,
  payload: { challan, history },
})

export const createChallanSuccess = challan => ({
  type: CREATE_CHALLAN_SUCCESS,
  payload: challan,
})

export const createChallanFail = error => ({
  type: CREATE_CHALLAN_FAIL,
  payload: error,
})

export const getChallanDetail = challanId => ({
  type: GET_CHALLAN_DETAILS,
  payload: challanId,
})

export const updateChallan = (challan, challanId, history) => ({
  type: UPDATE_CHALLAN,
  payload: { challan, challanId, history },
})

export const updateChallanSuccess = challan => ({
  type: UPDATE_CHALLAN_SUCCESS,
  payload: challan,
})

export const updateChallanFail = error => ({
  type: UPDATE_CHALLAN_FAIL,
  payload: error,
})

export const checkChallanNumber = (challanNumber, challanId) => ({
  type: CHECK_CHALLAN_NUMBER,
  payload: { challanNumber, challanId },
})

export const checkChallanNumberSuccess = challanNumber => ({
  type: CHECK_CHALLAN_NUMBER_SUCCESS,
  payload: { challanNumber },
})

export const checkChallanNumberFail = error => ({
  type: CHECK_CHALLAN_NUMBER_FAIL,
  payload: error,
})
export const resetChallanState = () => ({
  type: RESET_CHALLAN_STATE,
})
